   import React from "react";
import "../style/footer.css";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-main">

        {/* LEFT SIDE */}
        <div className="footer-brand">

          <h2 className="footer-title">VaultX Crypto</h2>

          <h3 className="footer-contact-title">Let's talk! 👋</h3>

          <p className="footer-text">+12 345 678 9101</p>
          <p className="footer-text">hello.vaultx@gmail.com</p>

          <p className="footer-text address">
            Cecilia Chapman 711-2880 Nulla St. Mankato<br />
            Mississippi 96522
          </p>
        </div>

        {/* PRODUCTS */}
        <div className="footer-col">
          <h4 className="footer-heading">PRODUCTS</h4>
          <p>Spot</p>
          <p>Inverse Perpetual</p>
          <p>USDT Perpetual</p>
          <p>Exchange</p>
          <p>Launchpad</p>
          <p>Binance Pay</p>
        </div>

        {/* SERVICES */}
        <div className="footer-col">
          <h4 className="footer-heading">SERVICES</h4>
          <p>Buy Crypto</p>
          <p>Markets</p>
          <p>Tranding Fee</p>
          <p>Affiliate Program</p>
          <p>Referral Program</p>
          <p>API</p>
        </div>

        {/* SUPPORT */}
        <div className="footer-col">
          <h4 className="footer-heading">SUPPORT</h4>
          <p>Bybit Learn</p>
          <p>Help Center</p>
          <p>User Feedback</p>
          <p>Submit a request</p>
          <p>API Documentation</p>
          <p>Trading Rules</p>
        </div>

        {/* ABOUT US */}
        <div className="footer-col">
          <h4 className="footer-heading">ABOUT US</h4>
          <p>About Bybit</p>
          <p>Authenticity Check</p>
          <p>Careers</p>
          <p>Business Contacts</p>
          <p>Blog</p>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <p className="footer-copy">
          © 2024 VaultX Crypto All Rights Reserved</p>

        <div className="footer-socials">
          <Facebook size={20} />
          <Twitter size={20} />
          <Instagram size={20} />
          <Linkedin size={20} />
        </div>
      </div>
    </footer>
  );
}
